import React from "react";
import LoadingL from "../assets/lotties/Loader.json";
import Lottie from "react-lottie";
import { Loader2 } from "lucide-react";

const loadingLottiFile = {
  loop: true,
  autoplay: true,
  animationData: LoadingL,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

function Loader() {
  return (
    <div id="overlayAllJd">
      <div id="loaderPos">
        {/* <Lottie height={100} width={100} options={loadingLottiFile} /> */}
        <Loader2 size={50} color="#EDC043" className="animate-spin" />
      </div>
    </div>
  );
}

export default Loader;
